import apiWrapper from 'Helpers/apiWrapper'
// import { encodeParams } from 'mailup-react-helpers' encodeURIComponent

const endpoints = (baseURL => {
  return {
    searchSubscriptionFlowConfiguration: () => `${baseURL}/api/configurations`,
    checkSubscriptionFlowConfigurationByListOfConfirmMsg: () =>
      `${baseURL}/api/check/byConfirmMessages`,
    checkSubscriptionFlowConfigurationByConfirmMsg: idConfirmMsg =>
      `${baseURL}/api/check/byConfirmMg/${encodeURIComponent(idConfirmMsg)}`,
    checkSubscriptionFlowConfigurationByListOfWelcomeMsg: `${baseURL}/api/check/byWelcomeMessages`,
    checkSubscriptionFlowConfigurationByWelcomeMsg: idWelcomeMsg =>
      `${baseURL}/api/check/byWelcomeMsg/${encodeURIComponent(idWelcomeMsg)}`
  }
})(process.env.BESUBSCRIPTIONFLOW_URL)

export const beSubscriptionFlowSearchSubscriptionFlowConfiguration = () => {
  const url = endpoints.searchSubscriptionFlowConfiguration()
  const requestBody = { IdConfirmMsg: 0 }

  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(requestBody)
  }).then(res => res.data)
}

export const beSubscriptionFlowCheckSubscriptionFlowConfigurationByListOfConfirmMsg = idsList => {
  const url = endpoints.checkSubscriptionFlowConfigurationByListOfConfirmMsg()
  const requestBody = {
    IdsConfirmMsg: idsList
  }

  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(requestBody)
  }).then(res => res.data)
}

export const beSubscriptionFlowCheckSubscriptionFlowConfigurationByConfirmMsg = idConfirmMsg => {
  const url = endpoints.checkSubscriptionFlowConfigurationByConfirmMsg(
    idConfirmMsg
  )

  return apiWrapper({
    method: 'post',
    url: url
  }).then(res => res.data)
}

export const beSubscriptionFlowCheckSubscriptionFlowConfigurationByListOfWelcomeMsg = ids => {
  const url = endpoints.checkSubscriptionFlowConfigurationByListOfWelcomeMsg

  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify({
      IdsWelcomeMsg: ids
    })
  }).then(({ data }) => data)
}

export const beSubscriptionFlowCheckSubscriptionFlowConfigurationByWelcomeMsg = idWelcomeMsg => {
  const url = endpoints.checkSubscriptionFlowConfigurationByWelcomeMsg(
    idWelcomeMsg
  )

  return apiWrapper({
    method: 'post',
    url: url
  }).then(({ data }) => data)
}
